export default "__VITE_ASSET__C$h$sk1w__"